export default __webpack_public_path__ + "static/media/3.45c006e7.png";